import {Component, OnDestroy, OnInit} from '@angular/core';
import {ComponentBase} from '../../core/entities/component-base';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Warehouse, Card, CardStocks, CardStocksDetails} from '../../core/entities/entities';
import {Observable} from 'rxjs/Observable';
import set = Reflect.set;
import {NowComponentBase} from '../../shared/base/NowComponentBase';
import {CardService} from '../../services/card.service';

@Component({
  templateUrl: './result-search-card.component.html',
  styleUrls: ['./result-search-card.component.css']
})
export class ResultSearchCardComponent extends NowComponentBase implements OnInit, OnDestroy {

  private _sortingCondition = 0;

  set sortingCondition(num: number){
    this.stock_status = {};
    this._sortingCondition = num;
  }

  get sortingCondition(){
    return this._sortingCondition;
  }

  private _stocks: CardStocks[];
  get stocks() {
    return this._stocks;
  }

  private _warehouses: Warehouse[];
  get warehouses() {
    return this._warehouses;
  }

  private stock_status : { [key: string]: {open: boolean, detail: CardStocksDetails}};

  public isOpen(cardStock: CardStocks): boolean{
    const key = '' + cardStock.id;
    if(this.stock_status[key]){
      return this.stock_status[key].open;
    }

    return false;
  }

  public openClose(cardStock: CardStocks){
    const key = '' + cardStock.id;
    if(!this.stock_status[key]){
      this.stock_status[key]={open:true, detail:null};
      this.spinnerService.show();
      this._cardServ.cardstocks_detail({cardId: key, sortingConditions: this.sortingCondition}).subscribe( ret => {this.stock_status[key].detail =ret; this.spinnerService.hide(); });
    } else {
      this.stock_status[key].open = !this.stock_status[key].open;
    }

  }

  public getDetail(cardStock: CardStocks): CardStocksDetails{
    const key = '' + cardStock.id;
    if(this.stock_status[key]){
      return  this.stock_status[key].detail;
    }
    return null;
  }

  public getDetailWarehouse(cardStock: CardStocks, index:number): any{
   if(this.getDetail(cardStock)){
     return this.getDetail(cardStock).warehouseStockDetails[index];
   }
   return null;
  }
  constructor(private _cardServ: CardService) { super(); }


  ngOnInit() {
    const me = this;
    super.ngOnInit();
    this.stock_status = {};
    this.spinnerService.show();
   this._cardServ.cardstocks().subscribe(ret => { this._cardServ.getWarehouses(ret).subscribe( warehouses => { me._stocks= ret; me._warehouses = warehouses;  this.spinnerService.hide();}) });

  }

  ngOnDestroy(): void {
   super.ngOnDestroy();
  }



}



// WEBPACK FOOTER //
// ./src/app/home/result-search-card/result-search-card.component.ts